import Vue from 'vue'
import Router from 'vue-router'
// import Intro from '@/components/Intro'
import Login from '@/components/Login'
import Cadastro from '@/components/Cadastro'
// import Cadastro2 from '@/components/Cadastro2'
// import BemVindo from '@/components/BemVindo'
import Inicio from '@/components/Inicio'
// import Busca from '@/components/Busca'
// import HorariosAgenda from '@/components/HorariosAgenda'
// import ConfirmarAgenda from '@/components/ConfirmarAgenda'
import Configuracoes from '@/components/Configuracoes'
// import OpcoesAgenda from '@/components/OpcoesAgenda'
import Pedidos from '@/components/Pedidos'
// import Pagamento from '@/components/Pagamento'
import Conta from '@/components/Conta'
import AlterarSenha from '@/components/AlterarSenha'
import Usuarios from '@/components/Usuarios'
import Saques from '@/components/Saques'
import Cupons from '@/components/Cupons'
import GerenciarCupons from '@/components/GerenciarCupons'
import Informacoes from '@/components/Informacoes'
import Carteira from '@/components/Carteira'
import Agendas from '@/components/Agendas'
import Servicos from '@/components/Servicos'
import GerenciarAgendas from '@/components/GerenciarAgendas'
import GerenciarServicos from '@/components/GerenciarServicos'
import DetalhesPedidos from '@/components/DetalhesPedidos'
// import HorarioAtendimento from '@/components/HorarioAtendimento'
import ConfigurarAgendas from '@/components/ConfigurarAgendas'
import Profissoes from '@/components/Profissoes'
import GerenciarProfissoes from '@/components/GerenciarProfissoes'
import Especialidades from '@/components/Especialidades'
import GerenciarEspecialidades from '@/components/GerenciarEspecialidades'
import RecuperarSenha from '@/components/RecuperarSenha'
// import PedidoEfetuado from '@/components/PedidoEfetuado'
import Contato from '@/components/Contato'
// import Saques from '@/components/Saques'
import Avaliacoes from '@/components/Avaliacoes'
import GerenciarUsuarios from '@/components/GerenciarUsuarios'
import { isMobile } from 'mobile-device-detect';
var loggedRoute 		= "Inicio";
var notLoggedRoute 	= "Login";

Vue.use(Router)

const checkLogin 	= (to, from, next) => {
    var self    	= this;

    // console.log("checkLogin()", to, from, next)

    if (!window.localStorage.getItem("_usuario")) {
        if (to.meta.auth == false || typeof to.meta.auth == "undefined") {
	   		next();
	   		return;             	
        }
        if (to.meta.auth == true) {
        }        
    } else {
        var usuario = null;
        try {
            usuario = JSON.parse(window.localStorage.getItem("_usuario"));
            window.__usuario = usuario;
            if (usuario.cod) {
		        if (to.meta.auth == false) {
				 	_this.push({ 
					   	name: loggedRoute,
					   	params: {
					   		"reload": 1 	
					   	}
				 	}).catch(()=>{});			
				 	// console.log("Esta logado e a pagina nao permite", _this);
				 	if (_this.currentRoute.params.reload == 1) {
				 		// console.log("Faz reload")
				 		window.location.reload();   		
			   		}
			   		return;             	
		        }

		        if (to.meta.auth && to.meta.level) {
		        	if (to.meta.level.indexOf(usuario.tipo) == -1) {
					 	_this.push({ 
						   	name: loggedRoute
					 	}).catch(()=>{});					        		
		        	}
		        }
	            
       
		   		next();
		   		return;            
            } else {
            }

        } catch(err) {
            // return false;
        }
    }
    
 	_this.push({ 
	   	name: notLoggedRoute
 	}).catch(()=>{});
};

var _this = new Router({
  	routes: [
	    // {
	    //   	path: '/intro/',
	    //   	name: 'Introducao',
	    //   	meta: {
	    //   		title: 		"Intro",
	    //   		auth: 		false,
	    //   	},
	    //   	component: Intro,
	    //   	beforeEnter: checkLogin,
	    // }, 	 
	    // {
	    //   	path: '/bem-vindo/',
	    //   	name: 'BemVindo',
	    //   	meta: {
	    //   		title: 		"Intro",
	    //   		auth: 		false,
	    //   	},
	    //   	component: BemVindo,
	    //   	beforeEnter: checkLogin,
	    // }, 	
	    {
	      	path: '/',
	      	name: 'Inicio',
	      	meta: {
	      		title: 		"Agenda Master",
	      		auth: 		true,
	      	},
	      	component: Inicio,
	      	beforeEnter: checkLogin,
	    }, 		     	     	
	    {
	      	path: '/login/',
	      	name: 'Login',
	      	meta: {
	      		title: 		"Login",
	      		auth: 		false,
	      	},
	      	component: Login,
	      	beforeEnter: checkLogin,
	    }, 
	    {
	      	path: '/cadastro/',
	      	name: 'Cadastro',
	      	meta: {
	      		title: 		"Cadastro",
	      		auth: 		false,
	      	},
	      	component: Cadastro,
	      	beforeEnter: checkLogin,
	    },
	    // {
	    //   	path: '/cadastro2/',
	    //   	name: 'Cadastro2',
	    //   	meta: {
	    //   		title: 		"Cadastro",
	    //   		auth: 		true,
		   //    	level: 		["entregador"],
	    //   	},
	    //   	component: Cadastro2,
	    //   	beforeEnter: checkLogin,
	    // },	     	    	    	      
	    {
	      	path: '/agendamentos/',
	      	name: 'Pedidos',
	      	meta: {
	      		title: 		"Agendamentos",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "contratante", "prestador"],
	      	},
	      	component: Pedidos,
	      	beforeEnter: checkLogin,
	    }, 	 
	    {
	      	path: '/avaliacoes/',
	      	name: 'Avaliacoes',
	      	meta: {
	      		title: 		"Avaliacoes",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin"],
	      	},
	      	component: Avaliacoes,
	      	beforeEnter: checkLogin,
	    }, 	 	          
	    // {
	    //   	path: '/categorias/',
	    //   	name: 'Categorias',
	    //   	meta: {
	    //   		title: 		"Categorias",
		   //    	auth: 		true,
		   //    	// backButton: true,
		   //    	level: 		["admin", "prestador"],
	    //   	},
	    //   	component: Categorias,
	    //   	beforeEnter: checkLogin,
	    // },	    
	    {
	      	path: '/minha-conta/',
	      	name: 'Conta',
	      	meta: {
	      		title: 		"Minha conta",
		      	auth: 		true,
		      	level: 		["admin", "contratante", "prestador"],
	      	},
	      	component: Conta,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/informacoes/',
	      	name: 'Informacoes',
	      	meta: {
	      		title: 		"Informações",
		      	auth: 		true,
		      	level: 		["admin", "prestador"],
		      	// backButton: true,
	      	},
	      	component: Informacoes,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/informacoes/',
	      	name: 'Informacoes',
	      	meta: {
	      		title: 		"Informações",
		      	auth: 		true,
		      	level: 		["admin", "prestador"],
		      	// backButton: true,
	      	},
	      	component: Informacoes,
	      	beforeEnter: checkLogin,
	    },	    
	    {
	      	path: '/saques/',
	      	name: 'Saques',
	      	meta: {
	      		title: 		"Saques",
		      	auth: 		true,
		      	level: 		["admin", "prestador"],
		      	// backButton: true,
	      	},
	      	component: Saques,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/cupons/',
	      	name: 'Cupons',
	      	meta: {
	      		title: 		"Cupons",
		      	auth: 		true,
		      	level: 		["admin", "prestador"],
		      	// backButton: true,
	      	},
	      	component: Cupons,
	      	beforeEnter: checkLogin,
	    },	
	    {
	      	path: '/cupons/cadastro',
	      	name: 'CadastrarCupons',
	      	meta: {
	      		title: 		"Cadastrar cupom",
		      	auth: 		true,
		      	// backButton: true,
		      	level: 		["admin", "prestador"],
	      	},
	      	component: GerenciarCupons,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/cupons/editar',
	      	name: 'EditarCupons',
	      	meta: {
	      		title: 		"Editar cupom",
		      	auth: 		true,
		      	// backButton: true,
		      	level: 		["admin", "prestador"],
	      	},
	      	component: GerenciarCupons,
	      	beforeEnter: checkLogin,
	    },			        	    
	    {
	      	path: '/configuracoes/',
	      	name: 'Configuracoes',
	      	meta: {
	      		title: 		"Configurações",
		      	auth: 		true,
		      	level: 		["admin", "prestador"],
		      	// backButton: true,
	      	},
	      	component: Configuracoes,
	      	beforeEnter: checkLogin,
	    },	 
	    // {
	    //   	path: '/opcoes-atendimento/',
	    //   	name: 'OpcoesAgenda',
	    //   	meta: {
	    //   		title: 		"Opções",
		   //    	auth: 		true,
		   //    	level: 		["admin", "prestador"],
		   //    	// backButton: true,
	    //   	},
	    //   	component: OpcoesAgenda,
	    //   	beforeEnter: checkLogin,
	    // },	 	       
	    {
	      	path: '/alterar-senha/',
	      	name: 'AlterarSenha',
	      	meta: {
	      		title: 		"Alterar senha",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "contratante", "prestador"],
	      	},
	      	component: AlterarSenha,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/carteira/',
	      	name: 'Carteira',
	      	meta: {
	      		title: 		"Carteira",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["prestador"],
	      	},
	      	component: Carteira,
	      	beforeEnter: checkLogin,
	    },	
	    // {
	    //   	path: '/horario-atendimento/',
	    //   	name: 'HorarioAtendimento',
	    //   	meta: {
	    //   		title: 		"HorarioAtendimento",
		   //    	auth: 		true,
		   //    	backButton: true,
		   //    	level: 		["admin", "prestador"],
	    //   	},
	    //   	component: HorarioAtendimento,
	    //   	beforeEnter: checkLogin,
	    // },		     
	    // {
	    //   	path: '/saques/',
	    //   	name: 'Saques',
	    //   	meta: {
	    //   		title: 		"Saques",
		   //    	auth: 		true,
		   //    	level: 		["prestador"],
	    //   	},
	    //   	component: Saques,
	    //   	beforeEnter: checkLogin,
	    // },	    
	    // {
	    //   	path: '/pedido-efetuado/',
	    //   	name: 'PedidoEfetuado',
	    //   	meta: {
	    //   		title: 		"Pedido efetuado",
		   //    	auth: 		true,
		   //    	// backButton: true,
		   //    	level: 		["prestador", "contratante"],
	    //   	},
	    //   	component: PedidoEfetuado,
	    //   	beforeEnter: checkLogin,
	    // },	
	    {
	      	path: '/contato/',
	      	name: 'Contato',
	      	meta: {
	      		title: 		"Contato",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["prestador", "contratante"],
	      	},
	      	component: Contato,
	      	beforeEnter: checkLogin,
	    },	 	       
	    {
	      	path: '/usuarios/',
	      	name: 'Usuarios',
	      	meta: {
	      		title: 		"Usuários",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin"],
		      	options: {
		      		"cadastrarBotaoTexto": 		"Cadastrar usuário",
		      		"cadastrarBotaoNome": 		"CadastrarUsuarios",
		      		"editarBotaoNome": 			"EditarUsuariosGeral",
		      		"tipo": 					"admin,contratante,prestador,entregador" 
		      	}
	      	
	      	},
	      	component: Usuarios,
	      	beforeEnter: checkLogin,
	    },	    	    
	    // {
	    //   	path: '/pesquisa/',
	    //   	name: 'Busca',
	    //   	meta: {
	    //   		title: 		"Pesquisa",
		   //    	level: 		["admin", "contratante", "prestador"],
		   //    	// auth: 		false,
		   //    	// backButton: true,
		   //    	// level: 		["contratante", "prestador"],
	    //   	},
	    //   	component: Busca,
	    //   	beforeEnter: checkLogin,
	    // },	
	    // {
	    //   	path: '/pagamento/',
	    //   	name: 'Pagamento',
	    //   	meta: {
	    //   		title: 		"Pagamento",
		   //    	level: 		["contratante"],
		   //    	auth: 		true,
		   //    	// backButton: true,
	    //   	},
	    //   	component: Pagamento,
	    //   	beforeEnter: checkLogin,
	    // },		    		    	 	 	    		 	       
	    {
	      	path: '/agendas/',
	      	name: 'Agendas',
	      	meta: {
	      		title: 		"Agendas",
		      	backButton: true,
		      	level: 		["prestador"],
	      	},
	      	component: Agendas,
	      	beforeEnter: checkLogin,
	    },	
	    {
	      	path: '/servicos/',
	      	name: 'Servicos',
	      	meta: {
	      		title: 		"Servicos",
		      	level: 		["prestador"],
		      	backButton: true,
	      	},
	      	component: Servicos,
	      	beforeEnter: checkLogin,
	    },		    
	    // {
	    //   	path: '/horarios-agenda/',
	    //   	name: 'HorariosAgenda',
	    //   	meta: {
	    //   		title: 		"Horarios da agenda",
		   //    	backButton: true,
	    //   	},
	    //   	component: HorariosAgenda,
	    //   	beforeEnter: checkLogin,
	    // },	
	    // {
	    //   	path: '/agenda/confirmar/',
	    //   	name: 'ConfirmarAgenda',
	    //   	meta: {
	    //   		title: 		"Confirmar",
		   //    	backButton: true,
	    //   	},
	    //   	component: ConfirmarAgenda,
	    //   	beforeEnter: checkLogin,
	    // },		        
	    {
	      	path: '/agendas/cadastro',
	      	name: 'CadastrarAgendas',
	      	meta: {
	      		title: 		"Cadastrar agenda",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["prestador"]
	      	},
	      	component: GerenciarAgendas,
	      	beforeEnter: checkLogin,
	    },	
	    {
	      	path: '/agendas/configuracoes',
	      	name: 'ConfigurarAgendas',
	      	meta: {
	      		title: 		"Gerenciar agenda",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["prestador"]
	      	},
	      	component: ConfigurarAgendas,
	      	beforeEnter: checkLogin,
	    },		    
	    {
	      	path: '/agendas/editar',
	      	name: 'EditarAgendas',
	      	meta: {
	      		title: 		"Editar agenda",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["prestador"]
	      	},
	      	component: GerenciarAgendas,
	      	beforeEnter: checkLogin,
	    },	
	    {
	      	path: '/agendamento/detalhes',
	      	name: 'DetalhesPedidos',
	      	meta: {
	      		title: 		"Detalhes do agendamento",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["prestador", "contratante", "admin"]
	      	},
	      	component: DetalhesPedidos,
	      	beforeEnter: checkLogin,
	    },		 
	    {
	      	path: '/servicos/cadastro',
	      	name: 'CadastrarServicos',
	      	meta: {
	      		title: 		"Cadastrar serviço",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["prestador"]
	      	},
	      	component: GerenciarServicos,
	      	beforeEnter: checkLogin,
	    },		    
	    {
	      	path: '/servicos/editar',
	      	name: 'EditarServicos',
	      	meta: {
	      		title: 		"Editar serviço",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["prestador"]
	      	},
	      	component: GerenciarServicos,
	      	beforeEnter: checkLogin,
	    },		    
	    {
	      	path: '/usuarios/cadastro',
	      	name: 'CadastrarUsuarios',
	      	meta: {
	      		title: 		"Cadastrar usuário",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin"]
	      	},
	      	component: GerenciarUsuarios,
	      	beforeEnter: checkLogin,
	    },	
	    {
	      	path: '/usuarios/editar',
	      	name: 'EditarUsuariosGeral',
	      	meta: {
	      		title: 		"Editar usuário",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin"]
	      	},
	      	component: GerenciarUsuarios,
	      	beforeEnter: checkLogin,
	    },	    		
	    {
	      	path: '/especialidades/',
	      	name: 'Especialidades',
	      	meta: {
	      		title: 		"Especialidades",
		      	auth: 		true,
		      	// backButton: true,
		      	level: 		["admin", "prestador"],
	      	},
	      	component: Especialidades,
	      	beforeEnter: checkLogin,
	    },	 	        	        
	    {
	      	path: '/especialidades/cadastro',
	      	name: 'CadastrarEspecialidades',
	      	meta: {
	      		title: 		"Cadastrar especialidade",
		      	auth: 		true,
		      	// backButton: true,
		      	level: 		["admin"],
	      	},
	      	component: GerenciarEspecialidades,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/especialidades/editar',
	      	name: 'EditarEspecialidades',
	      	meta: {
	      		title: 		"Editar especialidade",
		      	auth: 		true,
		      	// backButton: true,
		      	level: 		["admin"],
	      	},
	      	component: GerenciarEspecialidades,
	      	beforeEnter: checkLogin,
	    },	
	    {
	      	path: '/profissoes/',
	      	name: 'Profissoes',
	      	meta: {
	      		title: 		"Profissoes",
		      	auth: 		true,
		      	// backButton: true,
		      	level: 		["admin", "prestador"],
	      	},
	      	component: Profissoes,
	      	beforeEnter: checkLogin,
	    },	 	    
	    {
	      	path: '/profissoes/cadastro',
	      	name: 'CadastrarProfissoes',
	      	meta: {
	      		title: 		"Cadastrar profissão",
		      	auth: 		true,
		      	// backButton: true,
		      	level: 		["admin"],
	      	},
	      	component: GerenciarProfissoes,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/profissoes/editar',
	      	name: 'EditarProfissoes',
	      	meta: {
	      		title: 		"Editar profissão",
		      	auth: 		true,
		      	// backButton: true,
		      	level: 		["admin"],
	      	},
	      	component: GerenciarProfissoes,
	      	beforeEnter: checkLogin,
	    },		           
	    {
	      	path: '/recuperar-senha/',
	      	name: 'RecuperarSenha',
	      	meta: {
	      		title: 		"Recuperar senha",
	      		// auth: 		false,
	      	},
	      	component: RecuperarSenha,
	      	beforeEnter: checkLogin,
	    },	      	    
	    { path: '*', redirect: '/' }
  	]
})


const scrollPositions = Object.create(null)

_this.beforeEach((to, from, next) => {

  	let element = $(".page-content")[0];
  	if (element) {
	    scrollPositions[from.name] = element.scrollTop
  	}

  	next()
})

window.addEventListener('popstate', () => {
	setTimeout(function() {
	  	let currentRouteName = _this.history.current.name
	  	let element = $(".page-content")[0];
	  	if (element && scrollPositions[currentRouteName]) {
	    	element.scrollTop = scrollPositions[currentRouteName];
	    	scrollPositions[currentRouteName] = null;
	  	}
	}, 100);
})

export default _this;


// WEBPACK FOOTER //
// ./src/router/index.js